import { ColGroupDef } from 'ag-grid-community'
import { intl } from '../../../../../../i18n'
import { ProgramManagementRow } from '../../../programManagement'
import { calculateProductivity } from './aggregation'
import {
  RowValueGetter,
  RIGHT_ALIGN_STYLE,
  hoursValueFormatter,
  percentValueFormatter,
} from './common'

// --- Productivity group ---

export const productivityColumns: ColGroupDef<ProgramManagementRow> = {
  headerName: intl.formatMessage({
    id: 'programManagement.column.productivity',
  }),
  // 並び順はプロジェクト計画の生産性グループに合わせる: CV → CPI → SV → SPI → ETC → EAC → VAC
  children: [
    {
      colId: 'productivity.cv',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.cv',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'cv'),
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: hoursValueFormatter,
    },
    {
      colId: 'productivity.cpi',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.cpi',
      }),
      width: 70,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'cpi'),
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: percentValueFormatter,
    },
    {
      colId: 'productivity.sv',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.sv',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'sv'),
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: hoursValueFormatter,
    },
    {
      colId: 'productivity.spi',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.spi',
      }),
      width: 70,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'spi'),
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: percentValueFormatter,
    },
    {
      colId: 'productivity.etc',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.etc',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'etc'),
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: hoursValueFormatter,
    },
    {
      colId: 'productivity.eac',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.eac',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'eac'),
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: hoursValueFormatter,
    },
    {
      colId: 'productivity.vac',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.vac',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'vac'),
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: hoursValueFormatter,
    },
    {
      // 投入工数(実績工数)。他のリソース列と違い工程行(PROCESS/WORKGROUP)にも値が入るため、
      // resource ではなく行ごとの productivity.actualHour を一律参照する。
      colId: 'productivity.actualHour',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.actualHour',
      }),
      width: 90,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        params.data?.productivity?.actualHour ?? null,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueFormatter: hoursValueFormatter,
    },
  ],
}
